//////////////////
// Data Graph
//////////////////
App.DataGraph = (function() {

	App.register(function() {
		App.log("Registered: App.Gallery");
	});

  var scriptsRequested = false;
  var scriptsLoaded = false;
  var queue = [];
	var graphs = [];
	var selectors = {
		graph: ".graph",
    tooltip: ".graph-tooltip",
    figure: ".stat-figure",
    definition: ".stat-definition"
	};

  function loadScripts() {
    scriptsRequested = true;
    loadjs([
      '/assets/js/Chart.bundle.min.js',
      '/assets/js/Chart.min.js'
    ], App.DataGraph.scriptsLoaded);
  }

  function showCustomTooltip(tooltipModel, tooltip, autoFade) {
    try {
      if(tooltipModel.body) {

        // Get data
        var text = tooltipModel.body[0].lines[0];
        var parts = text.split(": ");

        // Update tooltip
        tooltip.find(selectors.figure).text(parts[1] + "%");
        tooltip.find(selectors.definition).text(parts[0]);

        // Show, if not visible
				gsap.fromTo(tooltip, { opacity:0 }, { opacity:1, duration: 1 });

      } else {

        // Hide
        gsap.to(tooltip, { opacity:0, delay:2, duration: 1 });
      }
    } catch(e) {
      console.log(e);
    }
  }

  return {

    renderGraph: function(dataGraphId, dataGraphPayload) {
      if(!scriptsRequested && !scriptsLoaded) {

        // Load the required scripts
        loadScripts();

        // Queue graph
        queue.push({ id: dataGraphId, data: dataGraphPayload });
        return(false);
      } else if(scriptsRequested && !scriptsLoaded) {

        // Queue graph
        queue.push({ id: dataGraphId, data: dataGraphPayload });
        return(false);
      } else {

        // Render graph
        var ctx = document.getElementById(dataGraphId).getContext('2d');
        var tooltip = $("#" + dataGraphId).siblings(selectors.tooltip);
        var graph = new Chart(ctx, {
            type: 'doughnut',
            data: {
              labels: dataGraphPayload.labels,
              datasets: [{
                label: dataGraphPayload.label,
                data: dataGraphPayload.data,
                backgroundColor: dataGraphPayload.backgroundColor,
                borderWidth: 0
              }]
            },
            options: {
              tooltips: {
                enabled: false,
                custom: function(tooltipModel) {
                  showCustomTooltip(tooltipModel, tooltip);
                }
              },
              cutoutPercentage: 80,
              animation: {
                animateScale: true
              },
              legend: {
                display: false
              }
            }
        });

        // Store the payload so we don't have to get it back from the graph API
        graph.payload = dataGraphPayload;
        graphs.push(graph);
        return(graph);
      }
    },

    autoplay : function(graph) {

      // Get the tooltip, but relative sibling to the graph canvas
      var tooltip = $(graph.controller.canvas).siblings(selectors.tooltip);

      // Recreate a fragment of the Chart JS model
      var models = [];
      for(var i = 0; i<graph.payload.labels.length; i++) {
        models.push({
          body: [{
            lines:[
              String(graph.payload.labels[i] + ": " + graph.payload.data[i])
            ]
          }]
        });
      }

      var position = 0;
      var interval = setInterval(function () {
        showCustomTooltip(models[position++], tooltip);
        if(position == models.length) {
          position = 0;
        }
      }, 6000);
      showCustomTooltip(models[position++], tooltip);
    },

    scriptsLoaded: function() {
      // Flag everything's ready
      scriptsLoaded = true;

      // Retry queue'd graphs
      for (var i = 0; i < queue.length; i++) {
        var item = queue[i];
        var graph = App.DataGraph.renderGraph(item.id, item.data);
        if(graph !== false) {
          App.DataGraph.autoplay(graph);
        }
      }
    }
  }

})();
